import React, {useEffect, useRef, useState} from "react";
import loadingIcon from "../../assets/svg/loading.svg";
import img404Icon from "../../assets/svg/img_404.svg";

const SafeImage = ({
                       src,
                       alt = "",
                       className = "",
                       loaderSize = 96,
                       isCoverImage = false,
                   }) => {
    const imgRef = useRef(null);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        setLoaded(false);
        setError(false);
    }, [src]);

    useEffect(() => {
        const img = imgRef.current;
        if (!img) return;

        if (img.complete && img.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [src]);

    if (!src || typeof src !== "string") {
        return (
            <img
                src={img404Icon}
                alt="image not found"
                className="safe-image__fallback"
            />
        );
    }

    return (
        <div
            className={`safe-image ${isCoverImage ? "safe-image--cover" : "safe-image--auto"} ${className}`}
        >
            <img
                ref={imgRef}
                src={src}
                alt={alt}
                loading="eager"
                decoding="async"
                onLoad={() => setLoaded(true)}
                onError={() => setError(true)}
                className={`safe-image__img ${
                    loaded && !error ? "is-loaded" : ""
                }`}
            />

            {!loaded && !error && (
                <img
                    src={loadingIcon}
                    alt="loading"
                    className="safe-image__loader"
                    style={{width: loaderSize, height: loaderSize}}
                />
            )}

            {error && (
                <img
                    src={img404Icon}
                    alt="image not found"
                    className="safe-image__fallback"
                />
            )}
        </div>
    );
};

export default SafeImage;
